@use '@fukuri-admins/ui/layout' as *;

.ImageInput {
  position: relative;
  display: inline-block;

  &__UploadLabel {
    display: flex;
    align-items: center;
    justify-content: center;
    width: var(--image-input-width, 200px);
    height: var(--image-input-height, 200px);
    border: 2px dashed border('Quaternary');
    border-radius: 8px;
    cursor: pointer;
    transition: border-color 0.2s ease;

    &:hover {
      border-color: border('Primary');
    }
  }

  &__PlaceholderText {
    font-size: 14px;
    color: text('Placeholder');
    text-align: center;
  }

  &__PreviewContainer {
    position: relative;
    display: inline-block;
  }

  &__PreviewImage {
    max-width: var(--image-input-width, 200px);
    max-height: var(--image-input-height, 200px);
    border-radius: 8px;
    border: 1px solid border('Quaternary');
    object-fit: contain;
  }

  &__RemoveButton {
    position: absolute;
    top: -8px;
    right: -8px;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background-color: background('Primary');
    border: 1px solid border('Quaternary');
    color: text('High');
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    font-weight: bold;
    line-height: 1;

    &:hover {
      background-color: background('Secondary');
    }
  }

  &__FileInput {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0;
  }
}
